import { render, staticRenderFns } from "./MtNewsList.vue?vue&type=template&id=6698b4e4&scoped=true&"
import script from "./MtNewsList.vue?vue&type=script&lang=js&"
export * from "./MtNewsList.vue?vue&type=script&lang=js&"
import style0 from "./MtNewsList.vue?vue&type=style&index=0&id=6698b4e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6698b4e4",
  null
  
)

export default component.exports